import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  OnInit
} from '@angular/core'

@Directive({
  selector: '[appDraggable]',
  standalone: true,
})
export class DraggableDirective implements OnInit {
  private _isDraggable = true
  private isDragging = false
  private startX = 0
  private startY = 0
  private initialX = 0
  private initialY = 0

  @Input('appDraggable') set ngDraggable (
    val: boolean | string | undefined | null
  ) {
    this._isDraggable = val === '' || val === true || val === 'true'
  }

  constructor (private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit () {
    // Only set style position absolute if not already set, to avoid overriding layout
    const currentPosition = window.getComputedStyle(
      this.el.nativeElement
    ).position
    if (!currentPosition || currentPosition === 'static') {
      this.renderer.setStyle(this.el.nativeElement, 'position', 'absolute')
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown (event: MouseEvent) {
    if (!this._isDraggable) return

    const target = event.target as HTMLElement
    if (
      ['INPUT', 'SELECT', 'OPTION', 'BUTTON', 'A', 'TEXTAREA'].includes(
        target.tagName
      )
    ) {
      return
    }

    this.isDragging = true
    this.startX = event.clientX - this.initialX
    this.startY = event.clientY - this.initialY
    event.preventDefault()
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove (event: MouseEvent) {
    if (!this.isDragging) return

    this.initialX = event.clientX - this.startX
    this.initialY = event.clientY - this.startY

    this.renderer.setStyle(
      this.el.nativeElement,
      'transform',
      `translate3d(${this.initialX}px, ${this.initialY}px, 0)`
    )
  }

  @HostListener('document:mouseup')
  onMouseUp () {
    this.isDragging = false
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart (event: TouchEvent) {
    if (!this._isDraggable) return

    const target = event.target as HTMLElement
    if (
      ['INPUT', 'SELECT', 'OPTION', 'BUTTON', 'A', 'TEXTAREA'].includes(
        target.tagName
      )
    ) {
      return
    }

    this.isDragging = true
    const touch = event.touches[0]
    this.startX = touch.clientX - this.initialX
    this.startY = touch.clientY - this.initialY
  }

  @HostListener('document:touchmove', ['$event'])
  onTouchMove (event: TouchEvent) {
    if (!this.isDragging) return

    const touch = event.touches[0]
    this.initialX = touch.clientX - this.startX
    this.initialY = touch.clientY - this.startY

    this.renderer.setStyle(
      this.el.nativeElement,
      'transform',
      `translate3d(${this.initialX}px, ${this.initialY}px, 0)`
    )
  }

  @HostListener('document:touchend')
  onTouchEnd () {
    this.isDragging = false
  }
}
